import { createSelector } from "reselect";

import { getCarrierCharges } from "./root";

export const getCarrierChargesListSelector = createSelector(
  [getCarrierCharges],
  carrierCharges => Object.values(carrierCharges),
);
